import { useEffect, useRef, useState } from 'react';
import closeIcon from '../../assets/icons/close-icon.svg';
import { CheckboxComponent } from '../buttons/CheckboxComponent';
import UsersService from '../../service/UsersService';
import { useAppDispatch, useAppSelector } from '../../store/hooks/hooks';
import { setDohvaceniUsers } from '../../store/slice/UsersSlice';
import { usersToUsersTable } from '../../common/utils/HelperFunction';
import { Users } from '../../common/types/types';

interface Props {
  setModalOn: (modalOn: boolean) => void;
  // setManageUserId: (id: number | string | undefined) => void;
  // userId: string | number | undefined;
}

export const ManageUser = (props: Props) => {
  const reachedUsers = useAppSelector((state) => state.users.dohvaceniUsers);
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [isAdmin, setIsAdmin] = useState<boolean>(false);

  const dispatch = useAppDispatch();

  const modalRef = useRef<HTMLDivElement>(null);

  const afterRequest = (response: any, requestData: any) => {
    setFirstName('');
    setLastName('');
    setEmail('');
    setIsAdmin(false);

    dispatch(setDohvaceniUsers(usersToUsersTable([...reachedUsers, requestData] as Array<Users>)));
  };

  const saveUser = () => {
    try {
      const requestData = {
        firstName,
        lastName,
        email,
        isAdmin,
      };

      UsersService.addUser(requestData)
        .then((response) => {
          afterRequest(response, requestData);
        })
        .finally(() => {
          console.log('finally!');
        });
    } catch (error) {}
  };

  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      if (!modalRef.current?.contains(event.target as Node)) {
        props.setModalOn(false);
        //props.setManageUserId(false);
      }
    };
    document.addEventListener('mousedown', handleMouseDown);

    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        props.setModalOn(false);
        //props.setManageUserId(false);
      }
    };
    document.addEventListener('keydown', handleEsc);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('keydown', handleEsc);
    };
  }, []);

  return (
    <div className='modal-active dark-100'>
      <div className='main-modal'>
        <div className='padding-bottom-5' ref={modalRef}>
          <form className='form modal-form relative'>
            <h3 className='font-h3-regular'>New User</h3>
            <img className='modal-form__close' src={closeIcon} alt='' onClick={() => props.setModalOn(false)} />
            <div className='form__item'>
              <label className='font-h6-regular margin-left-1' htmlFor='firstName'>
                First name
              </label>
              <input
                className='form__item__input font-h5-regular'
                type='text'
                onChange={(e) => setFirstName(e.target.value)}
                value={firstName || ''}
              />
            </div>
            <div className='form__item relative'>
              <label className='font-h6-regular margin-left-1' htmlFor='lastName'>
                Last name
              </label>
              <input className='form__item__input font-h5-regular' onChange={(e) => setLastName(e.target.value)} value={lastName || ''}></input>
            </div>
            <div className='form__item relative margin-bottom-0'>
              <label className='font-h6-regular margin-left-1' htmlFor='email'>
                Email
              </label>
              <input className='form__item__input font-h5-regular' onChange={(e) => setEmail(e.target.value)} value={email || ''}></input>
              <div className='full-width-grey-300-line' />
            </div>

            <CheckboxComponent isChecked={isAdmin} setIsChecked={setIsAdmin} uniqueName={'Is Admin'} type='1' />
            <br />

            <div className='text-right margin-top-3'>
              <span className='button-tertionary font-h5-medium' onClick={() => props.setModalOn(false)}>
                Cancel
              </span>
              <span onClick={saveUser} className='button-primary margin-left-2'>
                Save changes
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
